<div class="ui-g ui-g-nopad hidefilter-pos">
    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
        <div class="float-right">
            <p-checkbox class="padding-0" value="0" binary="true" (onChange)="hideFilter($event)">
            </p-checkbox>
            <span class="hidefilter-txt" translate> label_map_view_hide_filter</span>
        </div>
    </div>
</div>

<div class="ui-g shift-planning-section">
    <div class="ui-g-12 ui-g-nopad" *ngIf="!hideFilterSection">
        <div class="manage-shift-filters">
        <div class="form-field ui-g-12 ui-md-5 ui-lg-4 filter-search">
            <div class="form-label">
                <label></label>
            </div>
            <div class="form-control-c">
                <input autocomplete="off" [(ngModel)]="searchData" type="text" pInputText
                    [placeholder]="'label_search_shift_planning' | translate"
                    (input)="applySearchFilter()" />
            </div>
        </div>

        <div *ngIf="!disableProvider" class="form-field ui-g-12 ui-md-2 ui-lg-2 filter-provider">
            <div class="form-label">
              <label for="availability" translate>label_driver</label>
            </div>
            <div class="form-control-c">
              <p-dropdown [options]="providerListFilter" [(ngModel)]="providerIdForFilter" (onChange)="onProviderChange()"
                [placeholder]="'label_all' | translate" [style]="{'width': '100%'}">
                <ng-template let-item pTemplate="selectedItem">
                    <span class="dropdown-ellipsis-text" [title]="item?.label">{{item?.label}}</span>
                </ng-template>
                <ng-template let-item pTemplate="item">
                    <span [title]="item?.label">{{item?.label}}</span>
                </ng-template>
              </p-dropdown>
            </div>
        </div>

        <div class="form-field ui-g-12 ui-md-2 ui-lg-2 filter-region">
            <div class="form-label">
              <label translate>label_service_region</label>
            </div>
            <div class="form-control-c">
              <p-multiSelect autocomplete="off" [options]="serviceRegionList"
                [defaultLabel]="'label_all' | translate" [style]="{'width': '100%'}"
                [(ngModel)]="selectedServiceRegionIds" filter="filter" [resetFilterOnHide]="true"
                (onChange)="onServiceRegionChange()">
              </p-multiSelect>
            </div>
        </div>

        <div class="form-field ui-g-12 ui-md-2 ui-lg-2 filter-ends-on">
            <div class="form-label">
                <label translate>label_ends_on</label>
            </div>
            <div class="form-control-c">
                <p-dropdown [(ngModel)]="endsonFilter" [options]="endsOnFilterTableList"
                    [style]="{'width': '100%'}" (onChange)="onEndsOnFilter($event,dt)">
                </p-dropdown>
            </div>
        </div>

        
        <div *ngIf="showCustomDatePicker" class="form-field ui-g-12 ui-md-4 ui-lg-2">
            <div class="form-label">
              <label for="driverAvailability" translate>label_date</label>
            </div>
            <div class="form-control-c">
              <p-calendar [showIcon]="true" [(ngModel)]="customDate" (onSelect)="changeFilter($event)"
                [placeholder]="'label_date' | translate">
              </p-calendar>
            </div>
        </div>

      
        <div class="form-field ui-g-12 ui-md-4 ui-lg-3 pln-but filter-action-buttons">
            <div class="form-label">
                <label>&nbsp;</label>
            </div>
            <div class="form-control-c display-buttons">
                <i class='fa fa-refresh reste-btn mr-5' [class.disabled]="!endsonFilter && !providerIdForFilter && !searchData && !selectedServiceRegionIds.length" (click)="onResetFilter(dt)"></i>
                <button pButton class="save-btn w-auto" [disabled]="!endsonFilter && !providerIdForFilter && !selectedServiceRegionIds.length" type="button" [label]="'Save Filter' | translate"
                 (click)="saveFilter()"></button>
            </div>
        </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-3 pln-but member-container" style="width: 47%; float: right;">
            <div class="member-box permanent-member"></div>
            <span class="member-name mr-10">Permanent</span>
            <div class="member-box non-permanent-member"></div>
            <span class="member-name">Temporary (Assigned to team)</span>
            <div class="member-box new-member"></div>
            <span class="member-name">Newly Added Member</span>
        </div>


        <div class="form-field ui-g-12 ui-md-4 ui-lg-12">
            <div *ngIf="!(organizationLevelDispatch && !globalConfigMSFWPU)" class="page-buttons">
                <button pButton type="button" [label]="labelAddShift" appAddRow [table]="dt" [newRow]="newRow()"
                    [disabled]="shiftButtonDisabled" (click)="addShiftBtn()"></button>
            </div>
        </div>
    </div>
    <div class="ui-g-12 ui-g-nopad shift-planning-table">
        <p-table #dt [value]="shiftAllData" dataKey="id" editMode="row" styleClass="shift-table"
            [globalFilterFields]="['shiftSchedule','selectedTeamList','teamNames']" [rows]="10"
            [paginator]="shiftAllData.length !== 0 ? true : false" [ngClass]="{ 'first-row-highlight': isEditEnable }">
            <!-- [globalFilterFields]="['shiftSchedule','weeklyAllocation','allocationStr','startTimeStr','endTimeStr','endDate','endDateTimeStr','selectedTeamList','teamNames']" -->
            <ng-template pTemplate="header">
                <!--<tr>
                    <th translate>label_weekly_allocation</th>
                    <th translate [class.d-none]="isEditEnable">label_permanent_members</th>
                    <th translate>label_shift_schedule</th>
                    <th translate>label_shift_time</th>
                    <th translate>label_ends_on_title</th>
                    <th translate>label_team_title</th>
                    <th translate>label_action_title</th>
                </tr>-->
                <tr>
                    <th translate>label_team_title</th>
                    <th translate [class.d-none]="isEditEnable">label_permanent_members</th>
                    <th translate [class.d-none]="isEditEnable">label_shift_name_title</th>
                    <th translate>label_weekly_allocation</th>
                    <th translate>label_shift_time</th>
                    <th translate [class.d-none]="isEditEnable">label_shift_start_date_title</th>
                    <th translate *ngIf="!isEditEnable">label_ends_on_title</th>
                    <th  *ngIf="isEditEnable"><Span translate>label_ends_on_title</Span> <span style="margin-left: 70%;"  translate>label_action_title</span></th>
                    <th translate *ngIf="!isEditEnable">label_action_title</th>                   
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-itemsData let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="itemsData">
                    <td [ngClass]="{'w-200': isEditEnable}" >
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_user_type</label>
                                    <label class="asterisk">*</label>
                                    <!--<p-dropdown [style]="{'width': '100%'}" [options]="endsOnTableList"
                                        [(ngModel)]="itemsData.endDate" (onChange)="endsOnCustomDate(itemsData,$event)">
                                    </p-dropdown>-->
                                   
                                    <p-dropdown [style]="{'width': '100%'}" [(ngModel)]="itemsData.userType" [disabled]="disableProvider"
                                        [filter]="false" [options]="userList" (onChange)="loginType(itemsData,$event)">
                                    </p-dropdown>
                                
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_shift_name</label>
                                    <label class="asterisk">*</label>
                                    <input autocomplete="off" class="w-170" type="text" maxlength="30"
                                    [placeholder]="'label_shift_planning_schedule' | translate"
                                    [(ngModel)]="itemsData.shiftSchedule" pInputText required />
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_shift_end_date</label> 
                                    <label class="asterisk">*</label>                                 
                                    <p-calendar [defaultDate]="maxDate" [showIcon]="true"
                                        [placeholder]="'label_shift_end_date' | translate"
                                        [minDate]="maxDate" 
                                        dateFormat="{{dateFormat}}"
                                        [(ngModel)]="itemsData.endDateTimeStr"
                                        [disabled]="disableDates">
                                    </p-calendar>
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_shift_end_time</label>  
                                    <label class="asterisk">*</label>
                                    <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12"
                                        [placeholder]="'label_end_time' | translate"
                                        (onBlur)="getEndTime(itemsData.endTimeStr, itemsData, ri)" [(ngModel)]="availableEndTime"
                                        [(ngModel)]="itemsData.endTimeStr" [defaultDate]="currentDate"
                                        required></p-calendar>
                                </div>
                                <!-- <div class="ui-g">
                                    <div class="form-field ui-g-12 ui-md-6 ui-lg-6 pl-0">
                                        <p-calendar [timeOnly]="true" hourFormat="12"
                                            [placeholder]="'label_start_time' | translate"
                                            [(ngModel)]="itemsData.startTimeStr" required></p-calendar>
                                    </div>
                                    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
                                        <p-calendar [timeOnly]="true" hourFormat="12"
                                            [placeholder]="'label_end_time' | translate"
                                            [(ngModel)]="itemsData.endTimeStr" required></p-calendar>
                                    </div>
                                </div> -->
                            </ng-template>
                            <!--<ng-template pTemplate="output">
                                {{itemsData.startTimeStr}} - {{itemsData.endTimeStr}}
                            </ng-template>-->
                            <ng-template pTemplate="output">
                                {{ itemsData.teamNames }}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td [ngClass]="{'w-200': isEditEnable}"  [class.d-none]="isEditEnable">
                        {{itemsData?.membersName ? itemsData?.membersName : '--'}}
                        <!-- support for overlay dropdown to dispaly multiple permanent members -->
                        <!-- <div class="member-wrapper" >
                            {{itemsData.spPermenantMembers.length ? itemsData.spPermenantMembers[0].userName : 'NA'}} 
                            <div class="icon-wrapper" #targetIcon>
                                <div class="empty-box"></div>
                                <i class="fa fa-angle-down icon"
                                *ngIf="itemsData?.spPermenantMembers.length > 1"
                                (click)="showPermanentMembers($event, itemsData?.spPermenantMembers, targetIcon)"
                                 aria-hidden="true"></i>   
                            </div>
                        </div> -->
                    </td>



                    <td [ngClass]="{'w-200': isEditEnable}"  [class.d-none]="isEditEnable">
                        {{itemsData?.shiftSchedule}}
                    </td>

                    

                    
                    <td [ngClass]="{'w-200': isEditEnable}" >
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_driver</label>
                                    <label class="asterisk">*</label>
                                    <p-dropdown [style]="{'width': '100%'}" [options]="providerList" (onChange)="onShiftProviderChange($event)"
                                        [(ngModel)]="itemsData.provider" [disabled]="(loginTypeisWeb && itemsData.userType === '20') || disableProvider" >
                                    </p-dropdown>
                                    <!--(onChange)="endsOnCustomDate(itemsData,$event)"-->
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_shift_end_on</label>
                                    <label class="asterisk">*</label>
                                    <p-dropdown [style]="{'width': '100%'}" [options]="endsOnTableList"
                                        [(ngModel)]="itemsData.endDate" (onChange)="endsOnCustomDate(itemsData,$event)">
                                    </p-dropdown>
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_weekly_allocationp</label>
                                    <label class="asterisk">*</label>
                                <div class="circle-checkbox nowrap">                                    
                                    <label *ngFor="let objCheckbox of daysList; let i=index">
                                        <input type="checkbox" [(ngModel)]="itemsData.weeklyAllocation[i].isMandatory"
                                            name="chk{{ri}}" value="itemsData.id">
                                        <span class="checkmark"><span class="chk-pos" translate>{{
                                                objCheckbox.displayValue }}</span></span>
                                    </label>
                                </div>
                                </div>
                                <div class="random"></div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{itemsData.allocationStr}}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td [ngClass]="{'w-200': isEditEnable}" >
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_team_name</label>
                                    <label class="asterisk">*</label>
                                    <p-dropdown [style]="{'width': '100%'}" [options]="teamList"
                                        [(ngModel)]="itemsData.selectedTeamList" (onChange)="onTeamSelect(itemsData, $event)" [disabled]="loginTypeisWeb && itemsData.userType === '20'" >
                                    </p-dropdown>
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_shift_start_date</label> 
                                    <label class="asterisk">*</label>                                 
                                    <p-calendar [defaultDate]="maxDate" [showIcon]="true"
                                        [placeholder]="'label_shift_start_date' | translate"
                                        [minDate]="minDate"
                                        dateFormat="{{dateFormat}}"
                                        [(ngModel)]="itemsData.startDateTimeStr"
                                        (click)="onStartDateClick(itemsData)"
                                        (onSelect)="onStartDateClick(itemsData)"
                                        >
                                    </p-calendar>
                                </div>
                                <div class="form-field form-control-c w-300">
                                    <label translate>label_shift_start_time</label>
                                    <label class="asterisk">*</label>
                                    <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12"
                                        [placeholder]="'label_start_time' | translate"
                                        (onBlur)="getTime(itemsData.startTimeStr, ri)"
                                        [(ngModel)]="itemsData.startTimeStr" [defaultDate]="currentDate"
                                        required></p-calendar>
                                </div>
                                <div class="random1"></div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{itemsData.startTimeStr}} - {{itemsData.endTimeStr}}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td [ngClass]="{'w-200': isEditEnable}"  [class.d-none]="isEditEnable">
                        {{itemsData?.startDateTimeStr}}
                    </td>
                   
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div *ngIf="(itemsData.userType != '10' && itemsData.userType != '20') || (itemsData.userType === '10' && chosenTeam === '') || (itemsData.userType === '10' && provider === '') || (itemsData.userType === '10' && !showteamMembers)" style="height: 250px;"></div>
                               
                                <div class="team-members">
                                    <div *ngIf="!loginTypeisWeb && itemsData.userType === '10' && showteamMembers" style="height: 250px;">
                                        <div><label class="team-member-header" translate>label_team_members</label></div>
                                        <div class="search-container">
                                            <i class="pi pi-search search-icon"></i>
                                            <input class="search-member" type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyTeamMemberFilter()" [placeholder]="'label_search_team_members' | translate" />
                                        </div>
                                        <table class="team-table mobile-team-table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Name</th>
                                                    <th>Team Name</th>
                                                    <th>Schedule</th>
                                                </tr>
                                            </thead>                                            
                                            <tbody>
                                                <tr *ngFor="let member of filteredTeamMembers()">
                                                    <td [ngStyle]="{'background-color': member.permanentSchedule ? '#cbefdc' : '#fcedce'}"><input type="checkbox" [(ngModel)]="member.selected"  (change)="updateShiftPlanUsers(member)"/></td> <!-- Checkbox before each member -->
                                                    <td [ngStyle]="{'background-color': member.permanentSchedule ? '#cbefdc' : '#fcedce'}">{{ member.name }} </td>
                                                    <td [ngStyle]="{'background-color': member.permanentSchedule ? '#cbefdc' : '#fcedce'}">{{ selectedLabel }}</td>
                                                    <td [ngStyle]="{'background-color': member.permanentSchedule ? '#cbefdc' : '#fcedce'}" *ngIf="member.userSchedules.length>0">{{ member?.userSchedules[0].slotTimeStr}}</td>
                                                    <td [ngStyle]="{'background-color': member.permanentSchedule ? '#cbefdc' : '#fcedce'}" *ngIf="member.userSchedules.length===0" style="text-align: left; padding-left: 7%;">-</td> <!-- Replace with actual member properties -->
                                                </tr>
                                                <tr *ngIf="filteredTeamMembers().length===0">
                                                    <td colspan="4" style="text-align: center; font-weight: 400;" translate>label_no_team_members</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div *ngIf="itemsData.userType === '20'" style="width: 350px; height: 250px;">
                                        <label class="team-member-header-web" translate>label_team_members</label>
                                        <label class="asterisk" style="color: #F44336;">*</label>
                                        <div class="search-container" style="width: 350px;">
                                            <i class="pi pi-search search-icon"></i>
                                            <input class="search-member" type="text" [(ngModel)]="searchTerm" (ngModelChange)="filterGetUsersList()" [placeholder]="'label_search_team_web' | translate" />
                                        </div>
                                       
                                        <table class="team-table"> 
                                            <thead>
                                                <tr>
                                                    <th style="width: 20px;"></th>
                                                    <th>Name</th>
                                                    
                                                </tr>
                                            </thead>  
                                            <tbody>
                                                <tr>
                                                    <td colspan="2" style="padding: 0;">
                                                        <div [ngStyle]="{'max-height': (searchTerm ? filterdUserList : getUsersList).length > 3 ? '90px' : 'auto', 'overflow-y': 'auto'}">
                                                            <table style="width: 100%;">
                                                                <tbody>
                                                                    <tr *ngFor="let member of (searchTerm ? filterdUserList : getUsersList)">
                                                                        <td style="width: 20px;"><input type="checkbox" [(ngModel)]="member.selected" (change)="updateShiftPlanUsersWeb(member)" /></td>
                                                                        <td>{{ member.label }}</td>
                                                                    </tr>
                                                                    <tr *ngIf="filterdUserList.length === 0">
                                                                        <td colspan="4" style="text-align: center; font-weight: 400;" translate>label_no_team_member_found</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>                                        
                                            <!--<tbody>
                                                <div style="height: 150px; overflow-y: auto; margin-top: 10px;">
                                                <tr *ngFor="let member of filterGetUsersList()">
                                                    <td><input type="checkbox" [(ngModel)]="member.selected" (change)="updateShiftPlanUsersWeb(member)"/></td> 
                                                    <td>{{ member.label }}</td>
                                                
                                                </tr>
                                                </div>
                                            </tbody>-->
                                        </table>
                                        
                                    </div>
                                </div>
                                <div class="shift-planning-footer">
                                    <div class="shift-planning-note">
                                        <label class="note-label" translate>note_next_operation</label>
                                    </div>
                                    <div class="shift-planning-actions">
                                        <div class="cancel-btns">
                                            <button pButton type="button" [label]="labelCancel" *ngIf="!itemsData.id" 
                                            (click)="deleteRow(ri)"></button>
                                        </div>
                                        <div class="cancel-btns">
                                            <button pButton type="button" [label]="labelCancel" *ngIf="itemsData.id && editing"
                                            pCancelEditableRow (click)="cancelEditedRow(itemsData,ri)"></button>
                                        </div>
                                        <div class="page-button">
                                            <button pButton type="button" [label]="labelSave" pSaveEditableRow
                                            (click)="onRowEditSave(itemsData,dt)"></button>
                                        </div>
                                    </div>
                                </div>
                                    
                                <!--<input autocomplete="off" class="w-170" type="text" maxlength="100"
                                    [placeholder]="'label_shift_planning_schedule' | translate"
                                    [(ngModel)]="itemsData.shiftSchedule" pInputText required />-->
                            </ng-template>
                            <!--<ng-template pTemplate="output">
                                {{ itemsData.shiftSchedule }}
                            </ng-template>-->
                            <!--<ng-template pTemplate="output">
                                {{ itemsData.endDate === '-1' || itemsData.endDate === 'never' ? 'Never' :
                                (itemsData.endDateTimeStr | date: 'MMM d, y') + '(' + (itemsData.timezoneAbbr ?
                                itemsData.timezoneAbbr : '') + ')'}}

                                <span *ngIf="isEditEnable">
                                    <img src="/assets/images/temp/edit-icon.svg" title="Add Bulk Schedule" class="cp mr-20"
                                        [ngClass]="{ 'dasable-button': isBulkScheduleDisabled || isEditEnable }"
                                        [attr.disabled]="isBulkScheduleDisabled ? true : null"
                                        (click)="!isBulkScheduleDisabled ? onRowAddShift(itemsData) : null">

                                   
                                    <img src="/assets/images/temp/tick-icon.svg" title="Save" class="cp mr-20" *ngIf="editing"
                                        pSaveEditableRow (click)="onRowEditSave(itemsData,dt)">
                                    <img src="/assets/images/temp/delete-icon.svg" title="Delete" class="cp"
                                        *ngIf="itemsData.id && !editing" pCancelEditableRow
                                        (click)="onRowEditCancel(itemsData, ri)">
                                    <img src="/assets/images/temp/cancel-icon.svg" title="Cancel" class="cp" *ngIf="!itemsData.id"
                                        (click)="deleteRow(ri)">
                                    <img src="/assets/images/temp/cancel-icon.svg" title="Cancel" class="cp"
                                        *ngIf="itemsData.id && editing" pCancelEditableRow (click)="cancelEditedRow(itemsData,ri)">
                                </span>

                               
                                    
                            </ng-template>-->
                            <ng-template pTemplate="output">
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                    <!-- Text Content -->
                                    <div>
                                        {{ itemsData.endDate === '-1' || itemsData.endDate === 'never' ? 'Never' :
                                        (itemsData.endDateTimeStr | date: 'MMM d, y') + ' (' + (itemsData.timezoneAbbr ? itemsData.timezoneAbbr : '') + ')' }}
                                    </div>
                            
                                    <!-- Icons -->
                                    <div *ngIf="isEditEnable" style="display: flex; gap: 10px;">
                                        <img src="/assets/images/temp/edit-icon.svg" title="Add Bulk Schedule" class="cp mr-20"
                                            [ngClass]="{ 'dasable-button': isBulkScheduleDisabled || isEditEnable }"
                                            [attr.disabled]="isBulkScheduleDisabled ? true : null"
                                            (click)="!isBulkScheduleDisabled ? onRowAddShift(itemsData) : null">
                            
                                        <img src="/assets/images/temp/tick-icon.svg" title="Save" class="cp mr-20" *ngIf="editing"
                                            pSaveEditableRow (click)="onRowEditSave(itemsData, dt)">
                            
                                        <img src="/assets/images/temp/delete-icon.svg" title="Delete" class="cp"
                                            *ngIf="itemsData.id && !editing" pCancelEditableRow  [ngClass]="{ 'dasable-button': isBulkScheduleDisabled || isEditEnable }"
                                            (click)="onRowEditCancel(itemsData, ri)">
                            
                                        <img src="/assets/images/temp/cancel-icon.svg" title="Cancel" class="cp" *ngIf="!itemsData.id"
                                            (click)="deleteRow(ri)">
                            
                                        <img src="/assets/images/temp/cancel-icon.svg" title="Cancel" class="cp"
                                            *ngIf="itemsData.id && editing" pCancelEditableRow (click)="cancelEditedRow(itemsData, ri)">
                                    </div>
                                </div>
                            </ng-template>
                            
                        </p-cellEditor>
                    </td>
                   
                    
                    <!--<td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="form-field form-control-c w-100">
                                    <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12"
                                        [placeholder]="'label_start_time' | translate"
                                        (onBlur)="getTime(itemsData.startTimeStr, ri)"
                                        [(ngModel)]="itemsData.startTimeStr" [defaultDate]="currentDate"
                                        required></p-calendar>
                                </div>
                                <div class="form-field form-control-c w-100">
                                    <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12"
                                        [placeholder]="'label_end_time' | translate"
                                        (onBlur)="getEndTime(itemsData.endTimeStr, ri)" [(ngModel)]="availableEndTime"
                                        [(ngModel)]="itemsData.endTimeStr" [defaultDate]="currentDate"
                                        required></p-calendar>
                                </div>
                               
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{itemsData.startTimeStr}} - {{itemsData.endTimeStr}}
                            </ng-template>
                        </p-cellEditor>
                    </td>-->
                    <!--<td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="form-field form-control-c">
                                    <p-dropdown [style]="{'width': '100%'}" [options]="endsOnTableList"
                                        [(ngModel)]="itemsData.endDate" (onChange)="endsOnCustomDate(itemsData,$event)">
                                    </p-dropdown>
                                </div>
                                <div class="form-field form-control-c" *ngIf="itemsData.endDate === 'custom'">
                                    <p-calendar [defaultDate]="maxDate" [minDate]="maxDate"
                                        [(ngModel)]="itemsData.endDateTimeStr" dateFormat="{{dateFormat}}"
                                        [showIcon]="true" [placeholder]="'label_date' | translate"></p-calendar>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ itemsData.endDate === '-1' || itemsData.endDate === 'never' ? 'Never' :
                                (itemsData.endDateTimeStr | date: 'MMM d, y') + '(' + (itemsData.timezoneAbbr ?
                                itemsData.timezoneAbbr : '') + ')'}}
                            </ng-template>
                        </p-cellEditor>
                    </td>-->
                    <!--<td>

                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div class="form-field form-control-c set-multiselect-width">
                                   
                                    <p-dropdown [style]="{'width': '100%'}" [(ngModel)]="itemsData.userType"
                                        [filter]="false" [options]="userList" (onChange)="loginType(itemsData,$event)">
                                    </p-dropdown>
                                </div>
                                <div class="form-field form-control-c set-multiselect-width"
                                    *ngIf="!loginTypeisWeb && itemsData.userType === '10' ">
                                   
                                    <p-dropdown [style]="{'width': '100%'}" [(ngModel)]="itemsData.selectedTeamList"
                                        [filter]="true" [options]="teamList">
                                    </p-dropdown>
                                </div>
                                <div class="form-field form-control-c set-multiselect-width"
                                    *ngIf="itemsData.userType === '20'">
                                    <p-multiSelect autocomplete="off" [options]="getUsersList"
                                        [defaultLabel]="'All' | translate" [(ngModel)]="itemsData.shiftPlanUsers"
                                        [style]="{'width': '100%'}" filter="filter" [resetFilterOnHide]="true">
                                    </p-multiSelect>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ itemsData.teamNames }}
                            </ng-template>
                        </p-cellEditor>
                    </td>-->
                    <td class="shift-planing-act" *ngIf="!isEditEnable">
                       <img src="/assets/images/temp/edit-icon.svg" title="Add Bulk Schedule" class="cp mr-20"
                            [ngClass]="{ 'dasable-button': isBulkScheduleDisabled || isEditEnable }"
                            [attr.disabled]="isBulkScheduleDisabled ? true : null"
                            (click)="!isBulkScheduleDisabled ? onRowAddShift(itemsData) : null">

                        <!--<img src="/assets/images/temp/edit-icon.svg" title="Edit" class="cp mr-20"
                            *ngIf="!editing && !shiftButtonDisabled" pInitEditableRow
                            (click)="onRowEditInit(itemsData)">
                        <img src="/assets/images/temp/edit-icon.svg" title="Edit" class="mr-20 blur-img"
                            *ngIf="!editing && shiftButtonDisabled" disabled>-->
                        <img src="/assets/images/temp/tick-icon.svg" title="Save" class="cp mr-20" *ngIf="editing"
                            pSaveEditableRow (click)="onRowEditSave(itemsData,dt)">
                        <img src="/assets/images/temp/delete-icon.svg" title="Delete" class="cp"
                            *ngIf="itemsData.id && !editing" pCancelEditableRow
                            (click)="onRowEditCancel(itemsData, ri)">
                        <img src="/assets/images/temp/cancel-icon.svg" title="Cancel" class="cp" *ngIf="!itemsData.id"
                            (click)="deleteRow(ri)">
                        <img src="/assets/images/temp/cancel-icon.svg" title="Cancel" class="cp"
                            *ngIf="itemsData.id && editing" pCancelEditableRow (click)="cancelEditedRow(itemsData,ri)">
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <!-- <p-paginator [rows]="groupLimit" [totalRecords]="totalRecords"   (onPageChange)="paginate($event)"></p-paginator> -->
    </div>
</div>

<div class="no-shift-section" *ngIf="shiftAllData.length === 0">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
        <img src="/assets/images/temp/no-shift-planning.svg" />
        <h4 translate>label_no_shift</h4>
    </div>
</div>

<p-confirmDialog header="Confirmation" icon="fa fa-question-circle" [acceptLabel]="labelYes" [rejectLabel]="labelNo">
</p-confirmDialog>

<p-overlayPanel class="grid-overlay-panel" [showCloseIcon]="true" #op>
    <div class="header-wrapper">
        <span class="title" translate>label_permanent_members_lowercase</span>
    </div>
    <div class="body-wrapper">
        <ol class="ol-list">
            <li class="text" *ngFor="let member of currentPermanentMembers">
                {{member?.userName}}
            </li>
        </ol>
    </div>
</p-overlayPanel>


<p-dialog [blockScroll]="true" [header]="labelAddShift" modal="true" [showHeader]="true" styleClass="edit-profile-popup"
  [style]="{width: '500px'}" responsive="true" [(visible)]="showDialog"  (onHide)="onHideDialog()">
  <div class="ui-g form-container">   
 
   <div class="ui-g-12">
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <div class="dialog-text">
           <p>Would you like to override the existing shift schedule or adjust it?</p>
        </div>
        <div class="mt-20 dialog-text">
            <p> <span> Overriding </span> the shift will remove the existing shifts and the newly applicable shift will come in effect.</p>
        </div>
        <div class="mt-20 dialog-text">
            <p><span> Adjusting </span> the shift will either merge the shift if it is overlapping and if not, then system will maintain the existing shift and add the newly applicable shift.</p>
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-g-nopad form-buttons">
        <div class="page-buttons mt-30">
            <button pButton type="button" [label]="labelOverride" 
                (click)="setOverrideValue()"></button>
        </div>
        <div class="adjust-btn mt-30">
            <button pButton type="button" [label]="labelAdjust" 
                (click)="setAdjustValue()"></button>
        </div>      
     
    </div>
  </div>
</p-dialog>